import { call } from 'redux-saga/effects';
import { board } from 'utils/whiteboard/BoardStateManager';

export function* onGridPanelClosedSaga() {
  // kill whiteboard. Important because this prevents breakouts from stupid state;
  // does not notify signaling, suppose that's ok. See if regression
  yield call(board.stop);
}
